import "./navbar.scss";
import React, { useState } from "react";
import { Offcanvas } from "react-bootstrap";
import { Link } from "react-router-dom";

import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Joinmodal from "../modals/Joinmodal";
import Registermodal from "../modals/Registermodal";
import { NAV_LINKS, useNavLinks } from "./useNavLinks";

const Navbar = () => {
  const [showSidebar, setShowSidebar] = useState(false);
  const handleCloseSidebar = () => setShowSidebar(false);
  const handleShowSidebar = () => setShowSidebar(true);
  const [activeLink, setActiveLink] = useState(null);

  const goToLink = useNavLinks();

  const handleNavClick = (link) => {
    setShowSidebar(false);
    setActiveLink(link.label);
    goToLink(link);
  };

  const [modals, setModals] = useState({
    join: false,
    register: false,
  });

  const closeModal = (name) =>
    setModals((prev) => ({ ...prev, [name]: false }));

  return (
    <>
      <section className="mainnavbar">
        <div className="custom-container">
          <div className="innernavbar">
            <Link to="/">
              <img src="/logo.svg" alt="logo" className="logo" />
            </Link>
            <div className="centernavbar">
              {NAV_LINKS.map((link) => (
                <a
                  key={link.label}
                  onClick={() => handleNavClick(link)}
                  style={{
                    cursor: "pointer",
                    transition: "color 0.3s ease",
                    color: activeLink === link.label ? "" : "",
                  }}
                >
                  {link.label}
                </a>
              ))}
            </div>
            <button
              className="joinbtn"
              onClick={() => {
                window.location.href = "https://app.traqstock.com";
              }}
            >
              Join as Investor
            </button>
            <button onClick={handleShowSidebar} className="menubtn d-none">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
              >
                <path
                  d="M3.33301 4.16699H16.6663"
                  stroke="#022348"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M3.33301 10H16.6663"
                  stroke="#022348"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M3.33301 15.833H16.6663"
                  stroke="#022348"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </button>
          </div>
        </div>
      </section>

      <Offcanvas
        show={showSidebar}
        onHide={handleCloseSidebar}
        className="mobilesidebar"
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>
            <Link to="/" onClick={handleCloseSidebar}>
              <img src="/logo.svg" className="logo" alt="logo" />
            </Link>
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div className="mainlinks">
            {NAV_LINKS.map((link) => (
              <a
                key={link.label}
                onClick={() => handleNavClick(link)}
                style={{
                  color: activeLink === link.label ? "" : "",
                  cursor: "pointer",
                  transition: "color 0.3s ease",
                }}
              >
                {link.label}
              </a>
            ))}
          </div>
        </Offcanvas.Body>
        <div className="sidebarbtn">
          <button
            className="joinbtn"
            onClick={() => {
              window.location.href = "https://app.traqstock.com";
            }}
          >
            Join as Investor
          </button>
        </div>
      </Offcanvas>

      <Joinmodal show={modals.join} onHide={() => closeModal("join")} />
    </>
  );
};

export default Navbar;
